import customAxios from '../../customAxios';
import { SEND_VERIFICATION_SMS } from '../../routes';

interface iSendVerifyCode {
  phoneNumber?: string;
  currency?: string;
  countryCode?: string;
  language?: string;
  userType?: any;
}

const sendVerificationSms = async ({
  phoneNumber,
  countryCode = '0098',
  currency = 'IIR',
  language = 'FA',
  userType
}: iSendVerifyCode) => {
  try {
    const res = await customAxios.post(SEND_VERIFICATION_SMS, {
      phoneNumber,
      countryCode,
      currency,
      language,
      userType
    });
    return res.data;
  } catch (e) {
    console.log(e);
    return false;
  }
};
export default sendVerificationSms;
